import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW4403Model } from './kymw4403.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FlexGrid, CellType } from '@grapecity/wijmo.grid';
import { EventArgs } from '@grapecity/wijmo';
import { GetPublishGoodsGroupSelectItemsService } from './api-services/get-publish-goods-group-select-items.service';
import { KYMW4403InputModel } from './vo/kymw4403-input.model';
import { KYMW4403OutputModel } from './vo/kymw4403-output.model';

/**
 * 掲載商品グループ選択画面を管理するクラス
 *
 * @export KYMW4403Component
 * @class KYMW4403Component
 */
@Component({
  selector: 'app-kymw4403',
  templateUrl: 'kymw4403.component.html',
  styleUrls: ['kymw4403.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW4403Component
  extends PlessViewHelperSub
  implements OnInit, AfterViewInit
{
  @ViewChild('btn_Set', { static: false }) btn_Set: ElementRef;
  @ViewChild('chk_Header', { static: false }) chk_Header: ElementRef;
  @ViewChild('dtg_List', { static: false }) dtg_List: FlexGrid;

  public model: KYMW4403Model = new KYMW4403Model();
  private _output: KYMW4403OutputModel = null;

  /**
   * Creates an instance of KYMW4403Component.
   *
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {GetPublishGoodsGroupSelectItemsService} getPublishGoodsGroupSelectItemsService
   * @memberof KYMW4403Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getPublishGoodsGroupSelectItemsService: GetPublishGoodsGroupSelectItemsService,
    private kymw00Model: KYMW00Model
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW4403Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4403';

    this.getPublishGoodsGroupSelectItemsService.execute(this.model, () => {
      this.model.list.forEach(_ => {
        if (this.model.selectedList.includes(_.id)) _.check = true;
      });
    });
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW4403Component
   */
  public ngAfterViewInit(): void {
    this.dtg_List.itemsSourceChanged.addHandler(
      (_g: FlexGrid, _e: EventArgs) => {
        _g.select(-1, -1);
      }
    );
    this.dtg_List.hostElement.addEventListener('click', e => {
      const ht = this.dtg_List.hitTest(e.pageX, e.pageY);
      if (ht.cellType === CellType.Cell && ht.col === 0) {
        const val = this.dtg_List.getCellData(ht.row, ht.col, false);
        this.dtg_List.setCellData(ht.row, ht.col, val ? false : true);
      }
      if (ht.cellType === CellType.ColumnHeader && ht.col === 0) {
        this.chk_Header.nativeElement.click();
      }
    });
  }

  /**
   * ボタン押下 設定
   *
   * @memberof KYMW4403Component
   */
  public set() {
    this._output = this.model.list.filter(_ => _.check).map(_ => _.id);
    this.closeFunction();
  }

  /**
   * ヘッダーチェックボックス 入力
   *
   * @memberof KYMW4403Component
   */
  headerCheck() {
    const val = this.chk_Header.nativeElement.checked ?? false;
    this.model.list.forEach(_ => (_.check = val));
  }

  /**
   * 呼び出し側から利用
   *
   */
  public getParams(): KYMW4403OutputModel {
    return this._output;
  }

  /**
   * 呼び出し側から利用
   *
   */
  public setParams(data: KYMW4403InputModel) {
    this.model.selectedList = data.selectedList;
    this.model.orderCode = data.orderCode;
    this.model.mediumType = data.mediumType;
  }
}
